import Box from "@mui/material/Box"
import { useEffect } from "react"
import LogoDefault from "../../assets/AircrewPortPages_default.svg"
import LogoRose from "../../assets/AircrewPortPages_rose.svg"
import LogoMint from "../../assets/AircrewPortPages_mint.svg"
import LogoSunset from "../../assets/AircrewPortPages_sunset.svg"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../contexts/AuthContext" // adjust path as needed
import { useThemeMode } from "../../contexts/ThemeContext"
import Typography from "@mui/material/Typography"

const logos = {
    default: LogoDefault,
    rose: LogoRose,
    mint: LogoMint,
    sunset: LogoSunset,
}

export default function Header() {
    const navigate = useNavigate()
    const { auth } = useAuth() // assumes your context provides this
    const { scheme } = useThemeMode()
    const isLoggedIn = !!auth?.token
    const currentLogo = logos[scheme] || logos.default

    // Preload hero image for better LCP
    useEffect(() => {
        const logoLink = document.createElement("link")
        logoLink.rel = "preload"
        logoLink.as = "image"
        logoLink.href = currentLogo
        document.head.appendChild(logoLink)

        return () => {
            document.head.removeChild(logoLink)
        }
    }, [currentLogo])

    const handleClick = () => {
        if (isLoggedIn) {
            navigate("/ports")
        } else {
            navigate("/")
        }
    }

    return (
        <Box
            sx={{
                alignItems: "flex-start",
                justifyItems: "end",
                justifyContent: "flex-end",
                backgroundColor: "rgba(0,0,0,0.5)",
                height: { xs: "10vh", sm: "15vh" },
                width: "100%",
                p: 6,
                pb: { xs: "10vh", sm: "15vh" },
                cursor: "pointer",
            }}
        >
            <header
                style={{
                    minHeight: "100%",
                    width: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                }}
                onClick={handleClick}
            >
                <Box
                    sx={{
                        display: "flex",
                        height: "100%",
                        width: "100%",
                        justifyContent: "center",
                        // pl: 3,
                    }}
                >
                    <img
                        src={currentLogo}
                        // height="100%"
                        alt="Aircrew Port Pages Logo"
                        loading="eager"
                        style={{ objectFit: "contain", paddingTop: "2.3rem" }}
                        // width="100%"
                    />
                    <Typography
                        color="primary.main"
                        sx={{
                            pt: 7,
                            alignContent: "center",
                            typography: { xs: "h5", sm: "h4", md: "h3" },
                        }}
                    >
                        Aircrew Port Pages
                    </Typography>
                </Box>
            </header>
        </Box>
    )
}
